/**
 * Typed envelope over `import.meta.env`. Vite reads `.env` files and exposes any
 * variable prefixed with `VITE_` to client code. Non-VITE vars are server-only
 * (and the drop-in has no server).
 *
 * The mapping is `VITE_<KEY>` → `env.<KEY>`. Keep the wrapper to centralize
 * the prefix translation and to keep call sites simple.
 */
export const env = {
  ENV: import.meta.env.VITE_ENV ?? 'local',
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN ?? '',
  /**
   * Internal-api host (scheme + hostname + optional port). Aligned with
   * `jetpay-frontend/new-web-app`'s `VITE_INTERNAL_API_HOST` for repo
   * convergence — same name, same shape.
   */
  INTERNAL_API_HOST: import.meta.env.VITE_INTERNAL_API_HOST ?? '',
  ADYEN_CLIENT_KEY: import.meta.env.VITE_ADYEN_CLIENT_KEY ?? '',
  /**
   * Build-time toggle preserved from the webpack era — controls whether
   * Adyen captures cardholder name on the card form. Read in T2's
   * AdyenDropin / use-adyen-checkout.
   */
  WEB_DROP_IN_SHOW_NAME: import.meta.env.VITE_WEB_DROP_IN_SHOW_NAME ?? '',
  /**
   * Host of the HPP web application for the resolved environment, without
   * scheme (e.g. `pay.dev.jetpay.baselinepayments.com`) — `expectedHppOrigin()`
   * prepends `https://`. Exception: a `http://localhost:<port>` value is used
   * verbatim, so local dev (where the HPP app runs over plain http) can
   * exercise the inbound `card-payment-submit` listener. Used to validate
   * inbound `postMessage` origins on the `/hpp-session` route. Set at deploy
   * time via the env-scoped GitLab CI variable `VITE_HPP_DOMAIN_NAME`.
   * When empty (e.g. local without an override), the inbound listener is
   * disabled — the route still works via `?showButton=1`.
   */
  HPP_DOMAIN_NAME: import.meta.env.VITE_HPP_DOMAIN_NAME ?? '',
}
